/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RevocaVoucherModalita } from './revoca-voucher-modalita';


export interface VoucherRevocaDTO { 
    modalita?: RevocaVoucherModalita;
    motivo?: string;
    data_revoca?: string;
    /**
     * Nome e cognome di chi ha revocato, o la sua email se l\'anagrafica e\' vuota
     */
    operatore?: string;
    /**
     * Importo speso dal ledger al momento della revoca
     */
    importo_speso?: number;
    /**
     * Importo da recuperare (BLOCCA_E_REGISTRA), 0 altrove
     */
    importo_da_recuperare?: number;
    /**
     * Importo stornato (BLOCCA_E_STORNA), 0 altrove
     */
    importo_stornato?: number;
    /**
     * Data dell\'annullamento della revoca (D-61); assente se la revoca e\' attiva
     */
    annullata_il?: string;
    /**
     * Nome e cognome di chi ha annullato la revoca, o la sua email se l\'anagrafica e\' vuota
     */
    annullata_da?: string;
    /**
     * Motivazione dell\'annullamento (testo libero)
     */
    motivo_annullamento?: string;
}



